<footer class="footer bg-dark">
  <div class="container py-2">
    <div class="row py-md-2">
      <div class="col-12 text-md-right">
        <ul class="m-0 p-0">
          @for (link of links; track link; let i = $index) {
          <li class="hf-footer-link d-sm-inline-block d-xs-block py-2">
            <button (click)="openNewWindow(link.value)">{{link.name | translate}}</button>
          </li>
          }
        </ul>
      </div>
    </div>
    <div class="row pb-0 pb-md-2">
      <div class="col-xs-12 col-sm-4 py-2 py-md-0 order-1">
        <p class="m-0 copyrights">
          <span>{{company.name}}</span>
        </p>
      </div>
      <div class="col-9 col-sm-4 py-2 py-md-0 text-md-right order-sm-2">{{applicationYear}}</div>
    </div>
  </div>
</footer>
